import Vue from 'vue';
import tinymce from './TinymceEditor.vue';

Vue.component('tinymce', tinymce);
